import React, { useState } from 'react';

import { createCharacter } from '../character.slice';
import { formatPicture } from '../../../core/services/image.service';

import { catchError } from '../../../core/catch-error';
import { FormBuilderModal } from '../../../components/form-builder-modal/form-builder-modal';
import { buildCharacterForm } from '../character-form.definition';
import { Project } from '../../../app/entities/project';
import { COVER_SIZE } from '../../../components/cover-image/cover-format';

import type { Frame } from '../../../lib/utils/transform-image';

type FormValues = {
  name: string;
  characterNumber?: number | string;
  description: string;
  personality: string;
  characteristics: string;
  appearance: string;
  gender: string;
};

type CreateCharacterProps = {
  projectId: string;
  onCancel: () => void;
};

export const CreateCharacterDrawer: React.FC<CreateCharacterProps> = ({ projectId, onCancel }) => {
  const [file, setFile] = useState<Frame>();

  const siblings = Project.getOne(projectId)?.characters ?? [];

  const onHandleSubmit = async (values: FormValues) => {
    try {
      // The input is a text field, so the value arrives as a string. Coerce here rather than
      // relying on the resolver, and send nothing when it is left blank so the API assigns
      // the next number itself.
      const { characterNumber, ...rest } = values;
      const parsed =
        characterNumber === '' || characterNumber === undefined
          ? undefined
          : Number(characterNumber);

      await createCharacter({
        characterInfo: parsed === undefined ? rest : { ...rest, characterNumber: parsed },
        projectId,
        file,
      });
    } catch (e) {
      catchError(e);
    }
  };

  const handleSetImage = async (file?: File) => {
    if (!file) {
      return;
    }

    const frame = await formatPicture(file, COVER_SIZE);
    setFile(frame);
  };

  const createCharacterFormDefinition = buildCharacterForm(true, handleSetImage, siblings);

  return (
    <FormBuilderModal
      model="contact"
      definition={createCharacterFormDefinition}
      onSubmit={onHandleSubmit}
      onCancel={onCancel}
    />
  );
};
